(function () {
  var navigationKey = 'yfl-localization-navigation-pending-v1';
  var recoveryWindowMs = 15000;
  var recoveryDeadline = 0;
  var timers = [];

  function readNavigationTimestamp() {
    try {
      return Number(window.sessionStorage.getItem(navigationKey)) || 0;
    } catch (error) {
      return 0;
    }
  }

  function clearNavigationTimestamp() {
    try {
      window.sessionStorage.removeItem(navigationKey);
    } catch (error) {
      // Recovery remains safe when session storage is unavailable.
    }
  }

  function isVisible(element) {
    if (!element || element.getAttribute('aria-hidden') === 'true') return false;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      style.pointerEvents !== 'none' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function hasActiveBlockingSurface() {
    var selectors = [
      'cart-drawer.active',
      'cart-drawer[open]',
      '#CartDrawer.active',
      'modal-dialog[open]',
      'quick-add-modal[open]',
      'product-modal[open]',
      'details[open] .menu-drawer',
      '.popup-modal--active',
      '.popup-overlay--active',
      '[role="dialog"][aria-modal="true"]:not([aria-hidden="true"])',
    ];

    return selectors.some(function (selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), function (element) {
        return (
          element.getAttribute('data-yfl-newsletter-popup-suppressed') !== 'true' &&
          !element.closest('[data-yfl-newsletter-popup-suppressed="true"]') &&
          isVisible(element)
        );
      });
    });
  }

  function isLocked() {
    var htmlOverflow = document.documentElement.style.overflow;
    var bodyOverflow = document.body.style.overflow;
    var lockClasses = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet'];

    return (
      htmlOverflow === 'hidden' ||
      htmlOverflow === 'clip' ||
      bodyOverflow === 'hidden' ||
      bodyOverflow === 'clip' ||
      lockClasses.some(function (className) {
        return (
          document.documentElement.classList.contains(className) ||
          document.body.classList.contains(className)
        );
      }) ||
      document.body.style.position === 'fixed'
    );
  }

  function recover() {
    if (Date.now() > recoveryDeadline || !document.body || hasActiveBlockingSurface() || !isLocked()) {
      return false;
    }

    var storedScrollY = window.scrollY;
    var bodyTop = document.body.style.top;
    var bodyTopMatch = bodyTop && bodyTop.match(/^-(\d+(?:\.\d+)?)px$/);

    if (bodyTopMatch) storedScrollY = Number(bodyTopMatch[1]);

    ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet'].forEach(function (className) {
      document.documentElement.classList.remove(className);
      document.body.classList.remove(className);
    });

    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');

    if (document.body.style.position === 'fixed') {
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');
      document.body.style.removeProperty('width');
      window.requestAnimationFrame(function () {
        window.scrollTo(0, storedScrollY);
      });
    }

    return true;
  }

  function markRecoveryWindow() {
    recoveryDeadline = Math.max(recoveryDeadline, Date.now() + recoveryWindowMs);
  }

  function scheduleRecovery() {
    timers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    timers = [0, 100, 500, 1500, 3500, 6500, 10000].map(function (delay) {
      return window.setTimeout(function () {
        recover();
        if (delay === 10000) clearNavigationTimestamp();
      }, delay);
    });
  }

  function startNavigationRecovery() {
    var navigationTimestamp = readNavigationTimestamp();

    if (!navigationTimestamp || Date.now() - navigationTimestamp > recoveryWindowMs) {
      clearNavigationTimestamp();
      return;
    }

    recoveryDeadline = navigationTimestamp + recoveryWindowMs;
    scheduleRecovery();
  }

  window.YflScrollLockSafety = {
    markRecoveryWindow: markRecoveryWindow,
    scheduleRecovery: scheduleRecovery,
    recover: recover,
  };

  window.addEventListener('pageshow', startNavigationRecovery);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startNavigationRecovery, { once: true });
  } else {
    startNavigationRecovery();
  }
})();
